import React, { useState } from "react";
import { TextField } from "@mui/material";

import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { auth, db } from "../api/firebase";
import { useDocumentData } from "react-firebase-hooks/firestore";
// redux - use
import { useNotification } from "../redux/useNotification";

const AddEventOverView = ({ setOpen, requestId }) => {
  // redux - Notification
  const { displayNotification } = useNotification();

  const [event] = useDocumentData(doc(db, "event", requestId));

  const [product, setProduct] = useState({
    overview: "",
    error: "",
    loading: false,
  });
  const { overview, error, loading } = product;

  // 値変更
  const handleChange = (e) => {
    setProduct({
      ...product,
      [e.target.name]: e.target.value,
    });
  };

  const [user] = useDocumentData(doc(db, "users", auth.currentUser.uid));
  // 登録処理
  const setRequestDataShop = async (e) => {
    e.preventDefault();
    setProduct({
      ...product,
      error: "",
      loading: true,
    });
    try {
      // 変更処理
      const docRef = doc(db, "event", requestId);
      await updateDoc(docRef, {
        overview,
        latestUpdatedAt: serverTimestamp(),
      });

      displayNotification({
        message: "イベント概要追加しました。",
        type: "success",
      });
      // const docRef = await addDoc(collection(db, "ddp", match, "targets"), {
      //   [target]: {},
      // });

      setProduct({
        error: "",
        loading: false,
      });
      // window.location.reload();
      setOpen(false);
    } catch (err) {
      console.log(err);
      setProduct({
        ...product,
        error: err.message,
        loading: false,
      });
    }
  };

  return (
    <>
      <div>
        <div className="mb-3">イベント概要</div>
        <form onSubmit={setRequestDataShop}>
          {/* 提供する対象 */}
          <textarea
            style={{ resize: "none", fontSize: "16px" }}
            type="text"
            name="overview"
            className="textarea textarea-bordered w-full h-60 p-1"
            placeholder={event?.overview}
            defaultValue={event?.overview}
            onChange={handleChange}
          ></textarea>

          {/* <TextField
            id="outlined-required"
            name="overview"
            label="イベント概要"
            defaultValue=""
            size="small"
            placeholder="当日の持ち物、事前に準備するもの..."
            className=" w-full "
            onChange={handleChange}
            required
            disabled={loading}
          ></TextField> */}

          {/* 登録ボタン */}
          <button
            data-mdb-ripple="true"
            data-mdb-ripple-color="light"
            className="inline-block px-6 py-2.5 mt-2 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
            disabled={loading}
          >
            {loading ? "送信しています..." : "送信"}
          </button>
          {error ? error : ""}
        </form>
      </div>
    </>
  );
};

export default AddEventOverView;
